export const COLORS = {
  MAIN: {
    GRADIENT: ['#C5F1C1', '#C5F1C1'],
  },
};
